import { createRoutine } from "redux-saga-routines";

const ChangeLanguage = createRoutine("CHANGE_LANGUAGE");
const Reset = createRoutine("RESET");
const UploadFile = createRoutine("UPLOAD_FILE");
const GetUnits = createRoutine("GET_UNITS");
const SetToolbarTitle = createRoutine("SET_TOOLBAR_TITLE");
const ToggleOrganizationModal = createRoutine("TOGGLE_ORGANIZATION_MODAL");
const GetPaymentTypes = createRoutine("GET_PAYMENT_TYPES");
const UpdateCurrency = createRoutine("UPDATE_CURRENCY");
const GetCurrencyRates = createRoutine("GET_CURRENCY_RATES");
const GetStorages = createRoutine("GET_STORAGES");
const SetDefaultStorage = createRoutine("SET_DEFAULT_STORAGE");
const SetTranslations = createRoutine("SET_TRANSLATIONS");
const SetLangCodes = createRoutine("SET_LANG_CODES");
const SetHasStock = createRoutine("SET_HAS_STOCK");
const SetHasTax = createRoutine("SET_HAS_TAX");

export default {
  GetStorages,
  GetUnits,
  ChangeLanguage,
  Reset,
  UploadFile,
  SetToolbarTitle,
  ToggleOrganizationModal,
  GetPaymentTypes,
  UpdateCurrency,
  GetCurrencyRates,
  SetDefaultStorage,
  SetTranslations,
  SetLangCodes,
  SetHasStock,
  SetHasTax
};
